import React from 'react';
import { RefreshCw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { refreshInterventionDefinitionOptions } from '@generated';
import { createQueryDataTable, type PropsOfQueryDataTable, type RowOfQueryDataTable } from '~/shared/data-tables/query/QueryDataTable';
import { Button } from '~/shared/components/buttons/Button';
import { useMutation } from '~/util/http/useMutation';
import { TableActions } from '~/shared/data-tables/TableActions';

const InterventionDefinitionsDataTable = createQueryDataTable('intervention-definitions');
type RowType = RowOfQueryDataTable<typeof InterventionDefinitionsDataTable>;
type TableProps = PropsOfQueryDataTable<typeof InterventionDefinitionsDataTable>;

function ActionsCell({ row }: { row: RowType }) {
	const navigate = useNavigate();
	const refreshTask = useMutation(refreshInterventionDefinitionOptions);

	const onRefresh = () => {
		refreshTask.mutate({
			systemName: row.systemName
		});
	};

	return (
		<TableActions>
			<Button Icon={RefreshCw} aria-label="Refresh Task Definition" isDisabled={refreshTask.isPending} onClick={onRefresh} />
			<TableActions.ViewButton aria-label="Edit Task Definition" onClick={() => navigate(`edit/${row.id}`)} />
		</TableActions>
	);
}

const columnDefinitions = InterventionDefinitionsDataTable.columns([
	{
		header: 'Title',
		key: 'title',
		sortable: true
	},
	{
		header: 'System Name',
		key: 'systemName',
		sortable: true
	},
	{
		header: 'Version',
		key: 'version',
		width: 'w-[100px]',
		sortable: true
	},
	{
		header: 'Actions',
		key: 'actions',
		width: 'w-[100px]',
		renderCell: row => <ActionsCell row={row} />
	}
]);

export function InterventionDefinitionTable(props: TableProps) {
	return <InterventionDefinitionsDataTable.Table columns={columnDefinitions} emptyMessage="No intervention definitions found." {...props} />;
}
